import React from 'react'

function Copyright() {
  return (
    <div>
     <h1> تسجيل حقوق النشر</h1>
    </div>
  )
}

export default Copyright
